export default "Some of the most popular generative AI text models are:\n\n- **ChatGPT**\n- **Claude**\n- and **Gemini** \n"